import React, { FunctionComponent } from 'react';
import { useInternalBranding } from 'components/app/InternalBrandingContext';
import { FormattedMessage, useIntl } from 'react-intl';
import { Text } from 'mdlkit';
import { FocusShadowHyperlink } from 'components/shared/Styles';

interface Props {
  privacyLink?: string;
  termsLink?: string;
}

const LegalLink: FunctionComponent<Props> = ({
  privacyLink,
  termsLink,
}: Props) => {
  const { formatMessage: f } = useIntl();
  const internalBrandingData = useInternalBranding();

  return (
    <Text
      small
      aria-label="Clicking Create account means that you agree to MD Live's Terms of Use and Privacy Policy"
    >
      <FormattedMessage
        id="register.agreeToTerms"
        values={{
          branding: internalBrandingData?.displayName || 'MDLIVE',
          termsLink: (
            <FocusShadowHyperlink
              id="terms-link"
              href={termsLink || `${process.env.WWW_URL}/terms-of-use/`}
              data-track-event
              data-track={JSON.stringify({
                controlName: 'terms-of-use-main-link',
                controlText: f({ id: 'register.termsOfUse' }),
                destinationURL:
                  termsLink || `${process.env.WWW_URL}/terms-of-use/`,
              })}
            >
              <FormattedMessage id="register.termsOfUse" />
            </FocusShadowHyperlink>
          ),
          privacyLink: (
            <FocusShadowHyperlink
              id="privacy-link"
              href={privacyLink || `${process.env.WWW_URL}/privacy-policy/`}
              data-track-event
              data-track={JSON.stringify({
                controlName: 'privacy-policy-main-link',
                controlText: f({ id: 'register.privacyPolicy' }),
                destinationURL:
                  privacyLink || `${process.env.WWW_URL}/privacy-policy/`,
              })}
            >
              <FormattedMessage id="register.privacyPolicy" />
            </FocusShadowHyperlink>
          ),
        }}
      />
    </Text>
  );
};

export default LegalLink;
